import { useAppSelector } from "@app/store";
import Trash from "@assets/icons/trash.svg";
import { Button } from "@components/button";
import { GlobalLoader } from "@components/loader";
import { Modal } from "@components/modal";
import { useDevicesDispatch } from "@features/device";
import { useCallback } from "react";
import styles from "./remove-device-confirm.module.scss";

type Props = {
  hide: () => void;
  isOpen: boolean;
  deviceId: string;
};

export const RemoveDeviceConfirm = ({ hide, isOpen, deviceId }: Props) => {
  const isUpdating = useAppSelector((state) => state.device.isUpdating);
  const { updateDevice } = useDevicesDispatch();

  const onConfirm = useCallback(async () => {
    await updateDevice({ deviceId, delete: true });
    hide();
  }, [deviceId, hide, updateDevice]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={hide}
        title=" "
        className={styles.removeDeviceConfirm}
        bodyClassName={styles.bodyRemoveDeviceConfirm}
      >
        <p className={styles.title}>
          Вы уверены, что хотите удалить устройство?
        </p>
        <div className={styles.icon}>
          <Trash />
        </div>
        <div className={styles.buttons}>
          <Button onClick={hide}>Нет, оставить</Button>
          <Button type="danger" onClick={onConfirm}>
            Да, удалить
          </Button>
        </div>
      </Modal>
      {isUpdating && <GlobalLoader />}
    </>
  );
};
